import React from "react";
import CadastroRupturaBlocoCeramico from "../CadastroRupturaBlocoCeramico/CadastroRupturaBlocoCeramico";
import RelatorioRupturaBlocoConcretoPrint from "./RelatorioRupturaBlocoConcretoPrint";
import { calcularBlocosConcreto, criarBlocosConcreto, formatarCodigoBlocoConcreto } from "./blocoConcretoCalculos";

const CONFIG_BLOCO_CONCRETO = {
  colecao: "tblRupturaBlocoConcretos", quantidadeCompressao: 6, quantidadeAbsorcao: 0,
  chaveSequencial: "ruptura_bloco_concreto", templateCodigo: "RE-BL-0{numero}/{ano}",
  regexCodigo: /RE-BL-0(\d+)\/\d{4}/, rotaDetalhes: "/app/ruptura-bloco-concreto",
  titulo: "Ruptura de Bloco de Concreto", tituloNovo: "Nova Ruptura de Bloco de Concreto",
  tituloEditar: "Editar Ruptura de Bloco de Concreto", rotuloUnidades: "Blocos",
  tipoConcreto: true, criarBlocos: criarBlocosConcreto, calcularBlocos: calcularBlocosConcreto,
  Relatorio: RelatorioRupturaBlocoConcretoPrint,
  formatarCodigo: formatarCodigoBlocoConcreto,
};

export default function CadastroRupturaBlocoConcreto(props) {
  return <CadastroRupturaBlocoCeramico {...props} configuracao={CONFIG_BLOCO_CONCRETO} />;
}
